import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { q1O } from '../util/nE'
gsap.registerPlugin(ScrollTrigger)

class MediaColumns {
  constructor (el) {
    this.el = el
    this.items = this.el.querySelectorAll('.media-columns__row')
  }

  init () {
    this.buildTimelineIn()
  }

  buildTimelineIn () {
    gsap.set(this.el, { autoAlpha: 1 })
    gsap.set(this.items, { autoAlpha: 0 })
    ScrollTrigger.batch(this.items, {
      once: true,
      onEnter: (batch) => {
        batch.forEach((item, index) => {
          const mediaItem = item.querySelector('.c-media')

          const tl = gsap.timeline({
            defaults: {
              ease: (t) => {
                return q1O(t)
              },
              duration: 1,
            },
          })

          gsap.set(item, { autoAlpha: 1 })

          tl.fromTo(mediaItem, {
            autoAlpha: 0,
            y: 200,
          }, {
            autoAlpha: 1,
            y: 0,
          }, 0)
        })
      },
    })
  }

  destroy () {
  }
}

export default MediaColumns



//////////////////
// WEBPACK FOOTER
// ./scripts/components/MediaColumns.js
// module id = 53
// module chunks = 0